<template>
    <div>
        <page-header :title="$t('pages.admin.faq.index.title')" icon-class="mdi mdi-frequently-asked-questions">
            <div class="text-right">
                <router-link tag="a" :to="{name: 'admin.faq.create'}" class="text-primary font-weight-bold">
                    <i class="mdi mdi-plus"></i> {{ $t('pages.admin.faq.index.add_new_question') }}
                </router-link>
            </div>
        </page-header>

        <div class="row">
            <div class="col-12 grid-margin stretch-card">
                <div class="card shadow-sm">
                    <div class="card-body">

                        <div class="form-group mt-4">
                            <label for="preferred_language">{{ $t("pages.admin.faq.index.show_in_language") }}:</label>
                            <select class="form-control" id="preferred_language"  v-model="showInLanguage">
                                <option value="en">
                                    {{ $t('pages.admin.faq.global.lang.en') }}
                                </option>
                                <option value="de">
                                    {{ $t('pages.admin.faq.global.lang.de') }}
                                </option>
                                <option value="lb">
                                    {{ $t('pages.admin.faq.global.lang.lb') }}
                                </option>
                            </select>
                        </div>

                        <static-loading-indicator-icon/>
                        <div class="table-responsive" v-if="!$store.getters.isExecutingRequest">
                            <table class="table table-striped table-borderless" v-if="questions.length">
                                <thead>
                                    <tr>
                                        <th>{{ $t('pages.admin.faq.global.title') }}</th>
                                        <th>{{ $t('pages.admin.faq.global.text') }}</th>
                                        <th>{{ $t('pages.admin.faq.global.actions') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="question in questions" :key="question.id" v-if="question.titles[showInLanguage] !== 'null'">
                                        <td>{{ question.titles[showInLanguage] || '/' }}</td>
                                        <td v-html="question.texts_short[showInLanguage]  || '/'"></td>
                                        <td>
                                            <router-link tag="button" class="btn btn-warning btn-sm" :to="{name: 'admin.faq.edit', params: {question: question.id}}">
                                                <i class="mdi mdi-pencil"></i>
                                            </router-link>
                                            <button class="btn btn-danger btn-sm" @click="deleteQuestion(question.id)">
                                                <i class="mdi mdi-trash-can"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="alert alert-info" v-else>
                                {{ $t('pages.admin.faq.index.no_questions_found') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminFaqRepository from "../../../repositories/Admin/AdminFaqRepository";
import StaticLoadingIndicatorIcon from "../../Includes/StaticLoadingIndicatorIcon";
export default {
name: "FaqManagement",
    components: {StaticLoadingIndicatorIcon, PageHeader},
    data: () => ({
        questions: [],
        showInLanguage: 'en',
    }),
    methods: {
        deleteQuestion(questionId) {
            if(!window.confirm(this.$t('pages.admin.faq.index.delete_are_you_sure')))
                return false;

            AdminFaqRepository
                .deleteQuestion(questionId)
                .then((res) => {
                   this.$snotify.success(this.$t('pages.admin.faq.index.deleted_successfully'));
                   this.questions = this.questions.filter(q => q.id !== questionId);
                });
        }
    },
    mounted() {
        AdminFaqRepository
            .getQuestions()
            .then((res) => this.questions = res.data);
    }
}
</script>

<style scoped>

</style>
